import { createSlice } from '@reduxjs/toolkit';

import { ACTION_TYPES as DASHBOARD_ACTION_TYPES } from '../dashboards/constants';
import { ACTION_TYPES } from './constants';

const reportsSlice = createSlice({
  name: 'reports',
  initialState: {
    entities: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        DASHBOARD_ACTION_TYPES.GET_DASHBOARD_SUCCESS,
        (state, action) => {
          const incomingReports = action.payload?.entities?.reports || {};
          Object.entries(incomingReports).forEach(([id, report]) => {
            if (state.entities[id]) {
              Object.assign(state.entities[id], report);
            } else {
              state.entities[id] = report;
            }
          });
        },
      )
      .addCase(ACTION_TYPES.DELETE_REPORT_SUCCESS, (state, action) => {
        delete state.entities[action.payload];
      })
      .addCase(ACTION_TYPES.GET_REPORT_SUCCESS, (state, action) => {
        state.entities[action.payload._id] = action.payload;
      })
      .addCase(ACTION_TYPES.GET_REPORTS_BATCH_SUCCESS, (state, action) => {
        Object.values(action.payload || {}).forEach((report) => {
          if (report?._id) state.entities[report._id] = report;
        });
      })
      .addCase(ACTION_TYPES.CREATE_REPORT_SUCCESS, (state, action) => {
        state.entities[action.payload._id] = action.payload;
      })
      .addCase(ACTION_TYPES.UPDATE_REPORT_SUCCESS, (state, action) => {
        state.entities[action.payload._id] = action.payload;
      });
  },
});

export default reportsSlice.reducer;
